module.exports = __webpack_public_path__ + "41cacb0154bf863e6e3b14a5a6e3a4aa.grandmaster.png";


//////////////////
// WEBPACK FOOTER
// ./components/productVariants/rankPickers/mobileLegends/assets/grandmaster.png
// module id = gJ6o
// module chunks = 0